module.exports = __webpack_public_path__ + "img/raised.4463782d.svg";